import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { ChevronRight, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContactUsScreen = () => {
  const { setCurrentScreen } = useApp();
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    message: ''
  });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Message sent successfully! We\'ll get back to you soon.');
        setFormData({ ...formData, message: '' });
        setCurrentScreen('profile');
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      alert('Error sending message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-white pb-24">
      {/* Header */}
      <div className="px-6 pt-6 pb-4 flex items-center gap-4">
        <button
          onClick={() => setCurrentScreen('profile')}
          className="w-10 h-10 bg-black/5 rounded-xl flex items-center justify-center hover:bg-black/10 transition-all flex-shrink-0"
        >
          <ChevronRight size={18} className="text-black rotate-180" />
        </button>
        <img src="/logos/logo-black.jpg" alt="ATELIA" className="h-24 w-auto object-contain" />
      </div>

      <div className="px-6 pb-6">
        <p className="text-xs uppercase tracking-[0.2em] text-black/55 mb-2 font-bold">SUPPORT</p>
        <h1 className="text-2xl font-bold text-black uppercase tracking-wide">Contact Us</h1>
        <p className="text-sm text-black/55 mt-2">We're here to help</p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="px-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-wide text-black/55 mb-2 block font-bold">Name</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            required
            className="w-full px-4 py-3 bg-white border border-black/12 rounded-xl
              focus:outline-none focus:border-black/30 transition-all"
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-wide text-black/55 mb-2 block font-bold">Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            required
            className="w-full px-4 py-3 bg-white border border-black/12 rounded-xl
              focus:outline-none focus:border-black/30 transition-all"
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-wide text-black/55 mb-2 block font-bold">Message</label>
          <textarea
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
            required
            rows={6}
            className="w-full px-4 py-3 bg-white border border-black/12 rounded-xl resize-none
              focus:outline-none focus:border-black/30 transition-all"
            placeholder="Tell us how we can help..."
          />
        </div>

        <button
          type="submit"
          disabled={sending || !formData.message}
          className="w-full bg-black text-white py-4 rounded-xl font-bold uppercase
            flex items-center justify-center gap-2 hover:bg-black/90 transition-all
            disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send size={18} />
          {sending ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
};

export default ContactUsScreen;